<div class="right-side p-5">
  <div class="section">
    <div class="bkgimage">
      <form [formGroup]="invoiceStatusForm">
        <div class="row">
          <!-- Invoice Calculation Header -->
          <div class="col-12 text-start mb-4">
            <h2>Invoice Details Submitted</h2>
          </div>
        </div>
        <!-- Two Column Layout -->
        <div class="row">



          <div class="mb-3 col-md-3">
            <label for="eventId">Event ID : </label>
            <input class="form-control" type="text" id="eventId" formControlName="eventId" />
          </div>
          <div class="mb-3 col-md-3">
            <label for="eventName">Event Name : </label>
            <input class="form-control" type="text" id="eventName" formControlName="eventName" />
          </div>
          <!-- Intervention -->
          <div class="mb-3 col-md-3">
            <label for="intervention">Intervention : </label>
            <input class="form-control" type="text" id="intervention" formControlName="intervention" />
          </div>
          <!-- Component -->
          <div class="mb-3 col-md-3">
            <label for="component">Component : </label>
            <input class="form-control" type="text" id="component" formControlName="component" />
          </div>
        </div>
        <div class="row">
          <!-- Event Status -->
          <div class="mb-3 col-md-3">
            <label for="eventStatus">Event status : </label>
            <input class="form-control" type="text" id="eventStatus" formControlName="eventStatus" />
          </div>
          <div class="mb-3 col-md-3">
            <label for="invoiceID">Invoice ID :  </label>
            <input class="form-control" type="text" id="invoiceID" formControlName="invoiceID" />
          </div>
          <!-- Date -->
          <div class="mb-3 col-md-3">
            <label for="createdDate">Invoice Created Date : </label>
            <input class="form-control" type="date" id="createdDate" formControlName="createdDate" />
          </div>
        </div>
        <div class="row">
          <!-- Rate per MSME -->
          <div class="mb-3 col-md-3">
            <label for="ratePerMSME">Rate per MSME (in ₹) : </label>
            <input class="form-control" type="text" id="ratePerMSME" formControlName="ratePerMSME" />
          </div>
          <!-- No. of MSME Attended -->
          <div class="mb-3 col-md-3">
            <label for="noOfMSMEAttended">No. of MSME Attended :</label>
            <input class="form-control" type="text" id="noOfMSMEAttended" formControlName="noOfMSMEAttended" />
          </div>
          <div class="mb-3 col-md-3 border rounded mt-4">
            <label for="noOfMSMEAttended" style="padding-top: 6px;">Unverified MSME :</label>
            <label for="noOfMSMEAttended">{{unVerified}}</label>
          </div>
        </div>

        <div class="row">
          <!-- Total -->
          <div class="mb-3 col-md-2">
            <label for="total">Total (in ₹) :</label>
            <input class="form-control" type="text" id="total" formControlName="total" />
          </div>
        </div>

        <div class="row">
          <!-- GST -->
          <div class="mb-3 col-md-2">
            <label for="gst">GST Type :</label>
            <input class="form-control" type="text" id="gstType" formControlName="gstType" readonly />
          </div>
        </div>
        <div class="row">
          <!-- GST -->
          <div class="mb-3 col-md-2">
            <label for="gst">GST Percent (in %) :</label>
            <input class="form-control" type="text" id="gstPercent" formControlName="gstPercent" readonly />
          </div>
        </div>

        <!--<div class="row">-->
        <!-- GST -->
        <!--<div class="mb-3 col-md-2">
            <label for="gst">IGST (in %) :</label>
            <input class="form-control" type="text" id="igst" formControlName="igst" readonly />
          </div>
        </div>-->

        <div class="row">
          <!-- GST -->
          <div class="mb-3 col-md-2">
            <label for="gst">Total GST (in ₹) :</label>
            <input class="form-control" type="text" id="totalGST" formControlName="totalGST" readonly />
          </div>
        </div>

        <div class="row">
          <!-- Final Total -->
          <div class="mb-3 col-md-2">
            <label for="finalTotal">Final Total (in ₹) :</label>
            <!--<input class="form-control" type="text" id="finalTotal" formControlName="finalTotal" />-->
            <div>
              <input class="form-control" type="text" id="finalTotal" formControlName="finalTotal" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 col-md-3">
            <mat-label>Download Invoice : </mat-label>
            <mat-card-content>
              <a style="cursor: pointer"
                 class="btn btn-warning btn-sm mt-1"
                 (click)="onDownloadInvoice()">
                <i class="bi bi-download"></i> Download
              </a>
              <button class="btn btn-primary btn-sm mx-2 mt-1" (click)="openFilePreviewDialog()"><i class="bi bi-eye"></i> View File</button>
            </mat-card-content>
          </div>
        </div>

      </form>

      <form [formGroup]="paymentDetailsForm">
        <div class="row">
          <div class="col-12 text-start mb-4 mt-3">
            <h2>Payement Details By MSSIDC</h2>
          </div>
        </div>
        <!-- Two Column Layout -->
        <div class="row" *ngIf="showSection">
          <div class="mb-3 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Status</mat-label>
              <mat-select formControlName="status" (selectionChange)="DisableonPending($event)">
                <mat-option *ngFor="let status of statusList" [value]="status.id" [disabled]="status.disabled">{{ status.status }}</mat-option>
              </mat-select>
              <mat-error>
                <div *ngIf="paymentDetailsForm.get('status')?.errors?.['required'] && paymentDetailsForm.get('status')?.touched" class="alert alert-danger">
                  Please select status.
                </div>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="mb-3 col-md-3">
            <mat-label for="paymentDate">Payment Date : </mat-label>
            <input class="form-control paymentDate" matInput [matDatepicker]="startPicker" (focus)="startPicker.open()" formControlName="paymentDate" required
                   (keydown)="blockManualInput($event)"
                   [max]="maxDate"
                   readonly />
            <mat-datepicker #startPicker></mat-datepicker>
            <!--              <input class="form-control" type="date" id="paymentDate" formControlName="paymentDate" (keydown)="blockManualInput($event)" />-->
            <mat-error>
              <div *ngIf="paymentDetailsForm.get('paymentDate')?.errors?.['required'] && paymentDetailsForm.get('paymentDate')?.touched" class="alert alert-danger">
                Choose Date
              </div>
            </mat-error>
          </div>
          <!-- Intervention -->
          <div class="mb-3 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Payment Mode : </mat-label>
              <mat-select formControlName="paymentMode">
                <mat-option *ngFor="let status of paymentMode" [value]="status.id">{{ status.mode }}</mat-option>
              </mat-select>
              <mat-error>
                <div *ngIf="paymentDetailsForm.get('paymentMode')?.errors?.['required'] && paymentDetailsForm.get('paymentMode')?.touched" class="alert alert-danger">
                  Select Payment mode
                </div>
              </mat-error>
            </mat-form-field>
          </div>
          <!-- Component -->
          <div class="mb-3 col-md-3">
            <mat-label for="utrNumber">UTR Number : </mat-label>
            <input class="form-control" type="text" id="utrNumber" formControlName="utrNumber" />
            <mat-error>
              <div *ngIf="paymentDetailsForm.get('utrNumber')?.errors?.['required'] && paymentDetailsForm.get('utrNumber')?.touched" class="alert alert-danger">
                Enter Unique Transaction Reference (UTR) Number
              </div>
              <div *ngIf="paymentDetailsForm.get('utrNumber')?.errors?.['minlength'] && paymentDetailsForm.get('utrNumber')?.touched" class="alert alert-danger">
                Minimum length should be 5 characters
              </div>
              <div *ngIf="paymentDetailsForm.get('utrNumber')?.errors?.['maxlength'] && paymentDetailsForm.get('utrNumber')?.touched" class="alert alert-danger">
                Maximum length cannot be more than 15 characters
              </div>
              <div *ngIf="paymentDetailsForm.get('utrNumber')?.errors?.['pattern'] && paymentDetailsForm.get('utrNumber')?.touched" class="alert alert-danger">
                Invalid UTR number
              </div>
            </mat-error>
          </div>
          <!-- Event Status -->
          <div class="mb-3 col-md-3">
            <mat-label for="amount">Amount (in ₹) : </mat-label>
            <input class="form-control" type="text" id="amount" formControlName="amount" />
            <mat-error>
              <div *ngIf="paymentDetailsForm.get('amount')?.errors?.['required'] && paymentDetailsForm.get('amount')?.touched" class="alert alert-danger">
                Enter Amount
              </div>
              <div *ngIf="paymentDetailsForm.get('amount')?.errors?.['minlength'] && paymentDetailsForm.get('amount')?.touched" class="alert alert-danger">
                Amount should be Minimum  2 digits
              </div>
              <div *ngIf="paymentDetailsForm.get('amount')?.errors?.['maxlength'] && paymentDetailsForm.get('amount')?.touched" class="alert alert-danger">
                Amount should be Maximum  10 digits
              </div>
              <div *ngIf="paymentDetailsForm.get('amount')?.errors?.['pattern'] && paymentDetailsForm.get('amount')?.touched" class="alert alert-danger">
                Invalid Amount
              </div>
            </mat-error>
          </div>
          <!-- Submit and Cancel Buttons -->
          <div class="text-center mt-4">
            <button class="btn btn-success me-2" type="reset" (click)="onSubmit()" [disabled]="paymentDetailsForm.invalid">{{ showUpdate ? 'Update' : 'Submit Payment Details'}}</button>
            <button class="btn btn-danger" type="reset" (click)="onReset()">Reset</button>
          </div>
        </div>

        <div class="row" *ngIf="!showSection">
          <div class="mb-3 col-md-3">
            <label>Status</label>
            <input class="form-control" type="text" id="statusName" formControlName="statusName" />
          </div>
          <div class="mb-3 col-md-3">
            <label>Payment Date : </label>
            <input class="form-control" type="date" id="paymentDate" formControlName="paymentDate" />
          </div>
          <!-- Intervention -->
          <div class="mb-3 col-md-3">
            <label>Payment Mode : </label>
            <input class="form-control" type="text" id="paymentMode" formControlName="paymentMode" />
          </div>
          <!-- Component -->
          <div class="mb-3 col-md-3">
            <label>UTR Number : </label>
            <input class="form-control" type="text" id="utrNumber" formControlName="utrNumber" />
          </div>
          <!-- Event Status -->
          <div class="mb-3 col-md-3">
            <label>Amount : </label>
            <input class="form-control" type="text" id="amount" formControlName="amount" />
          </div>
        </div>
      </form>
      <div class="text-center mt-4">
        <button class="btn btn-info" type="reset" (click)="onBack()">Back</button>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="text-end">
      <button (click)="exportToExcel()" type="button" class="btn btn-sm btn-success me-2"><i class="bi bi-file-earmark-excel"></i> Export To Excel</button>
    </div>

  </div>

  <div class="section">
    List of Attended MSME Participants
    <div class="table-responsive">
      <table mat-table [dataSource]="dataSource" class="table table-striped table-bordered table-hover" matTableResponsive matSortActive="EnrollmentId" matSort matSortDirection="asc" matSortDisableClear>
        <ng-container matColumnDef="Sr.No">
          <th mat-header-cell *matHeaderCellDef>Sr. No.</th>
          <td mat-cell *matCellDef="let gr"> {{gr.rowNum}} </td>
        </ng-container>
        <ng-container matColumnDef="UdyamRegistrationNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Udyam Registration Number</th>
          <td mat-cell *matCellDef="let gr"> {{gr.udyamRegistrationNumber}} </td>
        </ng-container>
        <ng-container matColumnDef="ParticipantName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Participant Name</th>
          <td mat-cell *matCellDef="let gr"> {{gr.participantName}} </td>
        </ng-container>
        <ng-container matColumnDef="Designation">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Designation</th>
          <td mat-cell *matCellDef="let gr"> {{gr.designation}} </td>
        </ng-container>
        <ng-container matColumnDef="MobileNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Mobile Number</th>
          <td mat-cell *matCellDef="let gr"> {{gr.mobileNumber}} </td>
        </ng-container>
        <ng-container matColumnDef="EmailId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Email ID</th>
          <td mat-cell *matCellDef="let gr"> {{gr.emailId}} </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        Row shown when there is no matching data.
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">No data matching the filter</td>

        </tr>
      </table>

    </div>
    <mat-paginator #paginator
                   class="demo-paginator"
                   (page)="onPageChange($event)"
                   [length]="length"
                   [pageSize]="pageSize"
                   [showFirstLastButtons]="showFirstLastButtons"
                   [pageSizeOptions]="pageSizeOptions"
                   [hidePageSize]="hidePageSize"
                   [pageIndex]="pageIndex"
                   aria-label="Select page">
    </mat-paginator>
  </div>
</div>

